import React, { useEffect, useRef } from 'react'
import { Row, Col, Card } from "react-bootstrap";
import ChartPie from "./DonorsGenderPieChart"
import { useDonor } from '../../../../../context/donor/donor.context';
import { useTranslation } from "react-i18next";
const DonorsPieChart = () => {
    const {
        genderStatistics,
        fetchDonorsGenderStatistics,
        loading
    } = useDonor();
    const { t } = useTranslation();
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchDonorsGenderStatistics();
            hasFetchedRef.current = true;
        }
    }, []);

    const handleRefresh = () => {
        fetchDonorsGenderStatistics();
    };

    return (
        <Col xl={6} lg={6}>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>{t("Donor By Gender")}</Card.Title>
                    <button
                        className="btn btn-sm btn-primary"
                        onClick={handleRefresh}
                        disabled={loading}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="me-1"
                            viewBox="0 0 16 16"
                            style={{ marginBottom: '2px' }}
                        >
                            <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                            <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                        </svg>
                    </button>
                </Card.Header>
                <Card.Body style={{ minHeight: '500px' }}> {/* ✅ Increase min height */}
                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="sr-only">{t("Loading")}...</span>
                            </div>
                        </div>
                    ) : genderStatistics ? (
                        <>
                            <div style={{ height: '400px', width: '100%' }}> {/* ✅ Set explicit height */}
                                <ChartPie genderStatistics={genderStatistics} />
                            </div>
                            <div className="mt-3 text-center">
                                <p><strong>{t("donors.totalDonors")}:</strong> {genderStatistics.total}</p>
                                <div className="d-flex justify-content-around">
                                    <div>
                                        <span style={{ color: '#3b4cb8' }}>● </span>
                                        <strong>{t("Male")}:</strong> {genderStatistics.maleCount} ({genderStatistics.malePercentage}%)
                                    </div>
                                    <div>
                                        <span style={{ color: 'rgba(89, 59, 219, 0.7)' }}>● </span>
                                        <strong>{t("Female")}:</strong> {genderStatistics.femaleCount} ({genderStatistics.femalePercentage}%)
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center">{t("No data available")}</div>
                    )}
                </Card.Body>
            </Card>
        </Col>
    )
}

export default DonorsPieChart